/**
 * The way out of `409 NO_RATE_CARD` (TMMAPI-0154 §I): a link to Your price cards, beside the
 * "Adopt a price card before activating a plan." message. Only OWNER and ADMIN create or activate a
 * plan, and both can adopt a card.
 */
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function AdoptCardLink() {
  const { t } = useTranslation();
  return (
    <Button component={RouterLink} to="/rate-cards" color="inherit" size="small">
      {t('pages.rateCards.title')}
    </Button>
  );
}
